import { ResponsiveLayout } from '@robovision/rvai-base'
import { RouteNames } from '../moduleRouteNames/cameraManagement'
import type { RvaiRouteRecord } from '../types'


// We need to ignore "imports" for components properties in routes,
// because without it we have no possibility to import (dynamically) pages for specific router.
// Normally we don't need to import something from "pages" into router,
// but eslint doesn't know the difference between normal and dynamic imports.
export const routes: RvaiRouteRecord<RouteNames> = {
  path: '/camera-management',
  component: ResponsiveLayout,

  meta: {
    can: ['crud', 'Camera'],
  },

  children: [
    {
      // eslint-disable-next-line import/no-restricted-paths
      component: () => import('~modules/cameras/pages/CameraManagement.vue'),
      path: '',

      children: [
        {
          // eslint-disable-next-line import/no-restricted-paths
          component: () => import('~modules/cameras/components/CameraConfigurationsContent.vue'),
          path: 'configurations',
          name: RouteNames.CameraConfigurations,
          meta: {
            actionButton: 'create-configuration',
          },
        },
        {
          // eslint-disable-next-line import/no-restricted-paths
          component: () => import('~modules/cameras/components/CamerasContent.vue'),
          path: 'cameras',
          name: RouteNames.Cameras,
          meta: {
            actionButton: 'create-camera',
          },
        },
        {
          path: '',
          name: RouteNames.CameraManagement,
          redirect: { name: RouteNames.CameraConfigurations },
        },
      ],
    },
    {
      // eslint-disable-next-line import/no-restricted-paths
      component: () => import('~modules/cameras/pages/CameraConfigurationsSetup.vue'),
      path: 'configurations/setup/:id?',
      name: RouteNames.CameraConfigurationsSetup,
    },
  ],
}
